// extracted by mini-css-extract-plugin
module.exports = {"textHeader":"common_textHeader__heeKj","textSubHeader":"common_textSubHeader__35gZA","arrayItem":"common_arrayItem__2P4Ut","section":"common_section__1ggNJ"};